import { useRef } from "react";

/**
 * Keep a ref pointing at the latest value without re-running effects that
 * depend on it. Used to read fresh callbacks/state from stable closures.
 */
export function useLatest<T>(value: T): { readonly current: T } {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
